import React from 'react';

/**
 * LinkMode Component
 * 
 * Allows user to submit a deliverable by entering a URL
 */
const LinkMode = ({ 
  linkUrl, 
  setLinkUrl, 
  onSubmit,
  isUpdate,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && linkUrl.trim()) {
      onSubmit();
    }
  };

  return (
    <div className="deliverable-submit-modal__link-mode">
      <label className="deliverable-submit-modal__label">
        {isUpdate ? 'Enter a new link:' : 'Enter the link for this deliverable:'}
      </label>
      <input
        type="url"
        className="deliverable-submit-modal__input"
        placeholder="https://..."
        value={linkUrl}
        onChange={(e) => setLinkUrl(e.target.value)}
        onKeyDown={handleKeyDown}
        autoFocus
      />
      <p className="deliverable-submit-modal__hint">
        {isUpdate 
          ? 'Paste a new link to replace the one you submitted before.'
          : 'Paste a link to the file, document, or webpage that finishes this task.'}
      </p>
    </div>
  );
};

export default LinkMode;
